import React from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const perks = [
  "Largest inventory in Africa",
  "24/7 auto-ticketing + post-ticket automation",
  "Keep your airline incentives & markups",
  "Zero-stress setup, instant onboarding",
  "Tailored for African market (local payments, 24/7 support)",
];

function HomeWhyChooseSection() {
  return (
    <section className="w-full bg-gray-50 px-6 py-12 flex flex-col items-center">
      {/* Title */}
      <h2 className="text-xl font-bold text-center mb-6">
        Why Agents &amp; Travelpreneurs Choose Intraverse
      </h2>

      {/* Blue Card */}
      <div className="relative w-full max-w-md rounded-[22px] overflow-hidden">
        {/* gradient surface */}
        <div className="relative bg-primary1 p-5 rounded-[22px] z-10">
          <div className="absolute bottom-0 inset-x-0 z-0">
            <img src="/pattern.svg" alt="" className="w-full object-cover" />
          </div>
          {/* List */}
          <ul className="relative space-y-0 z-20">
            {perks.map((text, idx) => (
              <li key={idx} className="py-4 first:pt-1 last:pb-1">
                <div className="flex items-start gap-3">
                  <span className="shrink-0 w-8 h-8 rounded-full bg-white grid place-items-center">
                    <CheckCircleRoundedIcon
                      fontSize="small"
                      className="text-primary1"
                    />
                  </span>
                  <p className="text-white/95 text-sm leading-relaxed">
                    {text}
                  </p>
                </div>

                {/* divider */}
                {idx !== perks.length - 1 && (
                  <div className="mt-4 h-px bg-white/25" />
                )}
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="mt-5 relative z-10">
            <button className="w-full rounded-xl bg-gradient-to-b from-neutral-900 to-black text-white font-semibold py-3 shadow-md">
              Sign Up for Free Today!
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeWhyChooseSection;
